import React, { useState, useRef, useEffect } from "react";
import clsx from "clsx";
import classes from "./index.module.scss";
import { ArrowRightBoldIcon } from "@kohler-dsm-library/kohler-icons";

const isMobile = () => typeof window !== "undefined" && window.innerWidth <= 1024;

const TabbedNavigationHorizontal = ({
  tabs = [],
  align = "left",
  onTabChange,
  defaultActiveTab,
}) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab || tabs[0]?.id || tabs[0]?.text);
  const [underlineStyle, setUnderlineStyle] = useState({});
  const tabsRef = useRef([]);
  const [mobile, setMobile] = useState(isMobile());

  useEffect(() => {
    const handleResize = () => setMobile(isMobile());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const index = tabs.findIndex((tab) => (tab.id || tab.text) === activeTab);
    if (index !== -1 && tabsRef.current[index]) {
      const el = tabsRef.current[index];
      setUnderlineStyle({
        left: el.offsetLeft,
        width: el.offsetWidth,
      });
    }
  }, [activeTab, tabs]);

  // On hover, set active tab and call onTabChange
  const handleTabHover = (tab, index) => {
    setActiveTab(tab.id || tab.text);
    if (onTabChange) onTabChange(tab);
  };

  // On click, allow default navigation for <a>
  const handleTabClick = (tab, index, event) => {
    if (!tab.parentLink) {
      setActiveTab(tab.id || tab.text);
      if (onTabChange) onTabChange(tab);
    }
    // else: let <a> navigate as normal
  };

  return (
    <div className={classes.tabNavigationHorizontalBg}>
    <div
      className={clsx(
        classes.tabNavigationHorizontal,
        align === "center" && classes.tabNavigationHorizontalCenter
      )}
    >
      {tabs.map((tab, index) => (
        <React.Fragment key={tab.id || tab.text}>
          {tab.parentLink ? (
            <a
              ref={(el) => (tabsRef.current[index] = el)}
              className={clsx(
                classes.tabItem,
                activeTab === (tab.id || tab.text) && classes.active
              )}
              href={tab.parentLink}
              tabIndex={0}
              style={{ textDecoration: "none" }}
              onMouseEnter={() => handleTabHover(tab, index)}
              onFocus={() => handleTabHover(tab, index)}
              onClick={(e) => handleTabClick(tab, index, e)}
            >
              <span>{tab.text}</span>
              <ArrowRightBoldIcon
                size="xSmall"
                withBoundingBox={false}
                className={classes.mobileOnlyArrow}
              />
            </a>
          ) : (
            <button
              ref={(el) => (tabsRef.current[index] = el)}
              className={clsx(
                classes.tabItem,
                activeTab === (tab.id || tab.text) && classes.active
              )}
              onMouseEnter={() => handleTabHover(tab, index)}
              onFocus={() => handleTabHover(tab, index)}
              onClick={(e) => handleTabClick(tab, index, e)}
            >
              <span>{tab.text}</span>
              <ArrowRightBoldIcon
                size="xSmall"
                withBoundingBox={false}
                className={classes.mobileOnlyArrow}
              />
            </button>
          )}
          {mobile && index < tabs.length - 1 && (
            <div className={classes.menuItemDivider} />
          )}
        </React.Fragment>
      ))}
      <span
        className={clsx(
          classes.underline,
          !underlineStyle.width && classes.underlineNoTransition
        )}
        style={underlineStyle}
      />
      </div>
    </div>
  );
};

export default TabbedNavigationHorizontal;